import React from 'react'
import {
  useEvidenceIndexPage,
  useGetEvidenceIndexPageRequest,
} from 'src/pages/Evidence/evidence.hooks'
import { getColSortIcon, getNextColSortType } from './GridColumnSort.utils'
import { GridColumnSortEvidenceProps } from './GridColumnSort.constants'
import { GridColumnSort } from '.'

export const EvidenceGridColumnSort = ({
  type,
  isActive,
  colName,
  onSort,
}: GridColumnSortEvidenceProps): JSX.Element | null => {
  const req = useGetEvidenceIndexPageRequest()
  const { loading } = useEvidenceIndexPage(req)
  const currIcon = getColSortIcon(type, isActive)

  const applySorting = (e: React.MouseEvent) => {
    e.preventDefault()
    if (loading) {
      return
    }
    onSort({ colName, type: getNextColSortType(type) })
  }

  return (
    <GridColumnSort
      {...{ colName, showSpinner: false, currIcon, applySorting }}
    />
  )
}
